import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationRU from "./locales/ru/translation.json";
import translationEN from "./locales/en/translation.json";

const resources = {
  ru: {
    translation: translationRU,
  },
  en: {
    translation: translationEN,
  },
};

i18n
  .use(LanguageDetector) // определяет язык браузера
  .use(initReactI18next) // подключает react-i18next
  .init({
    resources,
    fallbackLng: "ru", // язык по умолчанию
    interpolation: {
      escapeValue: false, // React уже экранирует
    },
  });

export default i18n;
